import axios from 'axios'; // AJAX封装类
import * as qiniu from 'qiniu-js'
import { config } from '@/utils/config'; // 配置
import {
    post
} from '@/utils/http';
export default function(val) {
    // val数据类型是对象，调用该方法的时候传两个参数，file代表上传的文件，isSave代表上传的policyName参数是临时文件还是永久文件。

    // 获取文件上传token接口参数名policyName，可传入temporary（临时文件），permanent（永久文件）


    return new Promise((resolve, reject) => {
        axios.defaults.baseURL = config.axios_normalURL; //请求normalURL

        post('/qiniu/getToken', { policyName: val.isSave }, {}, '', this).then((res) => {

            axios.defaults.baseURL = config.axios_baseURL; //请求base url



            //图片上传前压缩
            // const options = {
            //     quality: 0.92,
            //     noCompressIfLarger: true
            //         // maxWidth: 1000,
            //         // maxHeight: 618
            // }

            // qiniu.compressImage(val.file, options).then(data => {
            // qiniu.compressImage(val.file).then(data => {
            //     console.log(上传图片才需要写到这里，因为司机管理页面要求可以上传视频，所以关于图片的注释了，22222222222222222222);
            //     console.log(val.file, 'val.file');
            //     console.log(config.qnKey, 'config.qnKey');
            //     console.log(res.data, 'res.data');


            //     const observable = qiniu.upload(val.file, config.qnKey, res.data);

            //     console.log(observable, 'observable');


            //     const observer = {
            //         next(res) {
            //             // ...

            //             // console.log(res, 'res========');
            //         },
            //         error(err) {
            //             // ...
            //         },
            //         complete(res) {

            //             resolve(res);
            //         }
            //     };
            //     const subscription = observable.subscribe(observer); // 上传开始
            //     // observable.subscribe(observer);
            // });


            // console.log(val.file, 'val.file');
            // console.log(config.qnKey, 'config.qnKey');
            // console.log(res.data, 'res.data');

            // 上传图片和视频
            const observable = qiniu.upload(val.file, config.qnKey, res.data);

            // console.log(observable, 'observable');
            let percent = ''; // 定义上传进度


            const observer = {
                next(res) {
                    // 接收上传进度信息的回调函数
                    // res.total.percent 上传进度
                    percent = res.total.percent;


                    // console.log(res, 'res========');
                },
                error(err) {
                    // 上传失败的回调函数
                    // err.data.error 上传错误信息
                },
                complete(res) {
                    // 上传成功的回调函数
                    // res.key 上传成功后的文件key
                    // console.log(res, 'res-=-=-=');
                    res.percent = percent; // 上传进度

                    resolve(res);
                }
            };
            const subscription = observable.subscribe(observer); // 上传开始
            // observable.subscribe(observer);
        })
        axios.defaults.baseURL = config.axios_baseURL; //请求base url
    })







}